const React = require('react');
const PaymentData = require('./payment-data');

function PaymentDataMobile(props) {
  return <PaymentData {...props} logosSize="medium" />;
}

module.exports = PaymentDataMobile;
